<app-logo-area
  [breadcrumbs]="breadcrumbs"></app-logo-area>
<main>
  <app-headline-section [title]="'My organizations'">
    <button type="button" class="btn cl-color-sea" (click)="dismiss()"><span>To my work</span></button>
  </app-headline-section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">Select an organization to work in.</p>
        </div>
      </div>
    </div>
  </section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <!-- As in the Video Toolkit: a filter only once the list is long enough to need one. -->
          @if (total() > 5) {
            <details class="card cl-tight cl-color-haze" [open]="total() > 10">
              <summary class="card-header">Filter: {{ shown().length }} of {{ total() }} shown</summary>
              <form novalidate class="card-body cl-form" (submit)="$event.preventDefault()">
                <input id="organizations-filter" type="text" class="form-control cl-field-sans"
                       placeholder="Filter by name" aria-label="Filter by name"
                       [value]="filter()" (input)="filter.set($any($event.target).value)">
              </form>
            </details>
          }

          <div class="cl-table-scroll">
            <table class="cl-table-data">
              <thead>
              <tr>
                <th class="cl-table-head cl-table-head-sort">
                  <button type="button" class="cl-btn-ghost" (click)="descending.set(!descending())">Organization
                    <i class="fas fa-fw" [class.fa-sort-up]="!descending()" [class.fa-sort-down]="descending()"
                       aria-hidden="true"></i></button>
                </th>
                <th class="cl-table-head cl-th-links"></th>
              </tr>
              </thead>
              <tbody>
                @if (loading()) {
                  <tr class="cl-tr-no-data">
                    <td colspan="100">
                      <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div>
                    </td>
                  </tr>
                } @else {
                  @for (entry of shown(); track entry.org.id) {
                    <tr class="cl-cursor-pointer" (click)="open(entry.url)">
                      <td>
                        <span class="cl-org">{{ entry.org.name }}</span>
                        @if (entry.org.parent_name) {
                          <small class="cl-color-text-steel"> via&nbsp;{{ entry.org.parent_name }}</small>
                        }
                      </td>
                      <td class="cl-td-links" width="1%">
                        <a [routerLink]="entry.url" class="cl-a-btn" (click)="$event.stopPropagation()">Switch</a>
                      </td>
                    </tr>
                  } @empty {
                    <tr class="cl-tr-no-data">
                      <td colspan="100">No data available.</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
